import { get } from 'lodash';

function getDropzoneDocuments(fileUpload, name) {
  return get(fileUpload, [name, 'files'], []);
}

export default getDropzoneDocuments;
